import { default as React, useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import List from "./list";
import { ValidationReductionsDto, GetValidationReductionsResponse, GetValidationReductionsQuery } from "core/backend/data";
import SheetDataPart from "components/sheetDataPart";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import { keys } from "ts-transformer-keys";
import Pagination from "components/pagination";
import { PageList } from "core/pages/pageList";
import {makePageChange, makeRequest} from "utils";

interface OwnState {
    applicationState: ApplicationState;
}
export const senderId = "validationReductions";
export const page_config: PageList =
{
    apiUrl: "validationReductions",
    webUrl: "validationReductions",
    menu: "menu:menuValidationReductions",
    title: "menu:titleValidationReductions",
    apiType: "data",
    response: JSON.stringify(keys<GetValidationReductionsResponse>()),
    dto: JSON.stringify(keys<ValidationReductionsDto>()),
    parameters: JSON.stringify(keys<GetValidationReductionsQuery>()),
    dateSteps: "H",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Day()
};

type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState }: PageProps) => {
    const initialData: GetValidationReductionsResponse = { data: [], totalRows: 0, skip: 0, take: 0, messages: [], rejected: false, lastModifiedOn: "" };
    const [data, setData] = useState(initialData);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const keysInDto = keys<ValidationReductionsDto>();
    const [pageNumber, setPageNumber] = useState(0);


    function handlePageChange(pageNumber: number) {
        makePageChange(pageNumber, applicationState, data, setPageNumber, (skip, take) => makeRequest(skip, take, applicationState, initialData, null, senderId, page_config, setLoading, setError, setData));
    }

    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange(page_config.dateSteps, false, false, keysInDto.filter(k => k.startsWith("coreNp_")).map(h => h.replace("coreNp_", "hub_")));
            makeRequest<GetValidationReductionsResponse>(0, applicationState.pageSize, applicationState, initialData, null, senderId, page_config, setLoading, setError, setData);
        })();
    }, [applicationState.selectedDate]);


    const pageCount = Math.ceil(data.totalRows / applicationState.maxRows);
    return (
        <>
            <SheetHeader showDownload={true} applicationState={applicationState} title={t(page_config.title)} pageConfig={page_config} />
            <SheetDataPart isLoading={isLoading} data={data.data} error={error}>
                <List
                    data={data.data.slice((pageNumber % 10) * applicationState.maxRows, ((pageNumber % 10) + 1) * applicationState.maxRows)} 
                    hubs={applicationState.selectedHubs.filter(h => h.isDisplayed && h.selected)} />
            </SheetDataPart>
            <Pagination
                currentPage={pageNumber}
                onPageClick={handlePageChange}
                pageCount={pageCount}
                realCount={data.totalRows}
            />
        </>
    );
};

export default withTranslation("page_validationReductions")(Page);
